/**
 * 获取翻译任务名称的能力
 */
export interface TranslationTaskNameGetter {
    /**
     * 获取翻译任务名称, 并设置到翻译模型中
     * @param taskId 任务ID
     * @returns 任务名称
     */
    getTaskName(taskId: string): Promise<string>;
}

export const TranslationTaskNameGetter = Symbol('TranslationTaskNameGetter');

/**
 * 设置翻译任务名称的能力
 */
export interface TranslationTaskNameSetter {
    /**
     * 设置到翻译模型中, 并调用接口设置到后端
     * @param taskId 任务ID
     * @param taskName 任务名称
     */
    setTaskName(taskId: string, taskName: string): Promise<void>;
}

export const TranslationTaskNameSetter = Symbol('TranslationTaskNameSetter');
